import { render } from "./drawer.md?vue&type=template&id=4dae3bd6"
import script from "./drawer.md?vue&type=script&lang=js"
export * from "./drawer.md?vue&type=script&lang=js"
script.render = render

export default script